function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M245,30.625c49.656,0,90.055,40.047,90.055,89.272S294.656,209.17,245,209.17c-49.656,0-90.055-40.048-90.055-89.272 S195.344,30.625,245,30.625 M245,0c-66.65,0-120.68,53.68-120.68,119.897S178.35,239.795,245,239.795 c66.65,0,120.68-53.68,120.68-119.897S311.65,0,245,0L245,0z"
})))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M320.572,297.734c9.082,0.19,78.624,3.836,78.624,70.379v91.262H90.804v-91.262c0-65.348,65.677-70.095,78.343-70.379 H320.572 M320.853,267.109H169.146c0,0-108.968,1.211-108.968,101.004c0,99.188,0,121.887,0,121.887h369.643 c0,0,0-22.699,0-121.887C429.821,268.922,320.853,267.109,320.853,267.109L320.853,267.109z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  version: 1.1,
  id: "Capa_1",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 490 490",
  style: {
    "enableBackground": "new 0 0 490 490"
  },
  xmlSpace: "preserve"
}, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);

export default __webpack_public_path__ + "static/media/user.a1247573.svg";
export { SvgComponent as ReactComponent };